export default "__VITE_ASSET__5ea34c2f__"